/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Payments';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const PaymentsIcon = withMuiAdapter(Base, 'Payments');
